// we should generate all of these hooks

import { Persona } from "~/Types/ApiModels";
import { ODataParameter, useDeleteModel, useGetModel, useGetModels, useUpdateModel } from "~/Hooks/Api/OData";

export const useGetPersonas = (parameter?: ODataParameter) => {
    return useGetModels<Persona>(parameter, "personas");
};

export const useGetPersona = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Persona>(id, parameter, "personas");
};

export const useUpdatePersona = () => {
    return useUpdateModel<Persona>("personas");
};

export const useDeletePersona = () => {
    return useDeleteModel<Persona>("personas");
};
